<template>
  <div class="ggtf-container">
    <!-- 头部 -->
    <div class="ggtf-header">
      <h1 class="ggtf-title">{{ $t('_ggtf._bt1') }}</h1>
      <div class="ggtf-tabs">
        <button :class="['ggtf-tab', { 'ggtf-active': activeTab === 'list' }]" @click="activeTab = 'list'">{{ $t('_ggtf._splb') }}</button>
        <button :class="['ggtf-tab', { 'ggtf-active': activeTab === 'my' }]" @click="activeTab = 'my'">{{ $t('_ggtf._wcyd') }}</button>
      </div>
    </div>

    <!-- 视频列表 -->
    <video-adv-list v-if="activeTab === 'list'"></video-adv-list>

    <!-- 我参与的 -->
    <video-my-adv-list v-else></video-my-adv-list>
  </div>
</template>

<script>
import VideoAdvList from '@/components/adv/VideoAdvList.vue'
import VideoMyAdvList from '@/components/adv/VideoMyAdvList.vue'
export default {
  name: 'AdDelivery',
  components: { VideoAdvList, VideoMyAdvList },
  data() {
    return {
      activeTab: 'list'
    }
  },
  methods: {}
}
</script>

<style scoped>
@import url('../../static/css_adv/1.css');
</style>
